import { AnalysisIssueBasketballEventGymClosed } from '@hefe/models';
import { Typography } from 'antd';
import IssueEventBlockComponent from '../issue-event-block/issue-event-block.component';

interface IssueBasketballEventGymClosedBodyComponentProps {
  issue: AnalysisIssueBasketballEventGymClosed;
}

export default function IssueBasketballEventGymClosedBody(
  props: IssueBasketballEventGymClosedBodyComponentProps
) {
  const { issue } = props;
  return (
    <>
      <Typography.Text strong>{issue.context.event.location}</Typography.Text>
      <IssueEventBlockComponent event={issue.context.event} />
    </>
  );
}
